import usdcCommon from "../common/usdc";

export const polimecUSDC = {
  id: 1337,
  height: 1151155,
  ...usdcCommon,
};

export default polimecUSDC;
